import React, { useEffect, useContext, useState } from "react";
import MorosityResidence from "../Components/MorosityResidence";
import Spinner from "react-bootstrap/Spinner";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FaFileExcel } from "react-icons/fa";

function MorosityReport() {
  const [residences, setResidences] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [downloadUrl, setDownloadUrl] = useState("");

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  useEffect(() => {
    async function fetch() {
      const result = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/residences/morosity/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setResidences(result.data.residences);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, rid]);

  const handleDownloadReport = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/reports/residences/download/morosity/${rid}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    setDownloadUrl(response.data.url);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Col>
        <Spinner animation="border" className="mb-2" />
        <h4>Procesando... Puede tardar algunos minutos, favor de esperar.</h4>
      </Col>
    );
  } else {
    return (
      <Col className="residences">
        <Col className="residences-header">
          <Row className="align-items-center">
            <Col lg={9} className="mb-2">
              <h4>Residencias en morosidad</h4>
            </Col>
            <Col lg={3} className="right icon mb-2">
              <FaFileExcel onClick={() => handleDownloadReport()} />
            </Col>
          </Row>
          {downloadUrl === "" ? (
            <></>
          ) : (
            <Row>
              <Col className="mb-3">
                <Alert variant="success">
                  Tu reporte ha sido generado con éxito.{" "}
                  <Alert.Link href={downloadUrl}>Descargar reporte.</Alert.Link>
                  .
                </Alert>
              </Col>
            </Row>
          )}
        </Col>
        <Col className="residences-content">
          <Col>
            <Row className="align-items-center">
              <Col lg={6}>
                <h6>Dirección</h6>
              </Col>
              <Col lg={2}>
                <p>Esperado</p>
              </Col>
              <Col lg={2}>
                <p>Acumulado</p>
              </Col>
              <Col lg={2}>
                <p>Pendiente</p>
              </Col>
            </Row>
          </Col>
          {residences.map((item) => (
            <MorosityResidence
              address={item.address}
              total={item.total}
              expectedPayment={item.expectedPayment}
              grandTotal={item.grandTotal}
              id={item._id}
              key={item._id}
            />
          ))}
        </Col>
      </Col>
    );
  }
}

export default MorosityReport;
